export class SnapSlider {
  listNode: HTMLElement
  maxNodes: number

  constructor(listNode: HTMLElement) {
    this.listNode = listNode as HTMLElement
    this.maxNodes = this.listNode.children.length
  }

  hiddenItems() {
    return this.maxNodes > this.numberOfViewportItems()
  }

  numberOfViewportItems(): number {
    const itemsInViewport: number =
      this.listNode.offsetWidth / this.getItemWidth()

    return itemsInViewport > 0.9 && itemsInViewport < 1.1
      ? Math.ceil(itemsInViewport)
      : Math.floor(itemsInViewport)
  }

  getItemWidth(): number {
    const firstNode: HTMLElement = this.listNode.firstChild as HTMLElement
    return firstNode ? firstNode.offsetWidth : 0
  }

  slide(direction: number) {
    if (this.listNode.firstChild) {
      const itemsInViewport: number = this.numberOfViewportItems()

      let currentPos = Math.round(
        this.listNode.scrollLeft / this.getItemWidth()
      )

      currentPos += direction

      if (itemsInViewport === 1) {
        if (this.listNode.scrollLeft <= 0 && direction === -1)
          currentPos = this.maxNodes - itemsInViewport
        else if (currentPos + itemsInViewport > this.maxNodes) currentPos = 0
      } else if (this.listNode.scrollLeft <= 0 && direction === -1) {
        currentPos = this.maxNodes - itemsInViewport - 1
      } else if (currentPos + itemsInViewport >= this.maxNodes) {
        currentPos = -1
      }

      if (itemsInViewport > 1) {
        currentPos += itemsInViewport
      }

      if (currentPos >= 0)
        if (this.listNode.children[currentPos]) {
          this.listNode.children[currentPos].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'end',
          })
        }
    }
  }
}
